import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=1c399406&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=ts&"
export * from "./Modal.vue?vue&type=script&lang=ts&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=1c399406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c399406",
  null
  
)

export default component.exports